import axios from "axios";
import BaseService from "./baseService";

export class ServiceWeeklyDigestController extends BaseService {
  async unsubscribeEmailNotifications({ p, s }: { p: string, s: string }): Promise<string> {
    const response = await axios.post(`/api/organizations/superadmin/weekly-digest/unsubscribe/${p}/${s}`);
    return response.data;
  }
  async fetchStatus({ p, s }: { p: string, s: string }): Promise<boolean> {
    const response = await axios.get(`/api/organizations/superadmin/weekly-digest/unsubscribe/status/${p}/${s}`);
    return response.data.status;
  }
  async recalculate(): Promise<void> {
    await axios.delete('/api/weekly-digest/current');
    await axios.post('/api/weekly-digest');
  }
  async sendToUser(userId: string): Promise<void> {
    await axios.post(`/api/weekly-digest/send/${userId}`);
  }
}

export const ServiceWeeklyDigest = new ServiceWeeklyDigestController();